module.exports = __webpack_public_path__ + "static/media/foto-destaque-banco-de-pedidos.7bb8ca2e.jpg";